import {
  InstallDesktopOutlined,
  InstallMobileOutlined,
} from '@mui/icons-material';
import { IconButton, Tooltip, Snackbar, Alert } from '@mui/material';
import { useEffect, useState } from 'react';

// Custom type for beforeinstallprompt event
interface BeforeInstallPromptEvent extends Event {
  prompt: () => void;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function InstallPWAButton() {
  const [installPrompt, setInstallPrompt] =
    useState<BeforeInstallPromptEvent | null>(null);
  const [showIosPrompt, setShowIosPrompt] = useState<boolean>(false);

  useEffect(() => {
    const handler = (event: BeforeInstallPromptEvent) => {
      event.preventDefault();
      setInstallPrompt(event);
    };

    window.addEventListener('beforeinstallprompt', handler as EventListener);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handler as EventListener
      );
    };
  }, []);

  useEffect(() => {
    // Detect if the user is on iOS and not using Safari
    const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isIos && isSafari) {
      setShowIosPrompt(true);
    }
  }, []);

  const handleInstallClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (installPrompt) {
      installPrompt.prompt();
      setInstallPrompt(null);
    }
  };

  return (
    <>
      <Tooltip title="Install the app">
        <span>
          <IconButton
            type="button"
            onClick={handleInstallClick}
            style={{ padding: '10px', fontSize: '16px' }}
            disabled={!installPrompt && !showIosPrompt}
          >
            {installPrompt ? (
              <InstallMobileOutlined />
            ) : (
              <InstallDesktopOutlined />
            )}
          </IconButton>
        </span>
      </Tooltip>

      {/* Show a guide for iOS users */}
      {showIosPrompt && (
        <Snackbar open={showIosPrompt} autoHideDuration={6000}>
          <Alert severity="info" onClose={() => setShowIosPrompt(false)}>
            On iOS, tap the <strong>Share</strong> button and select{' '}
            <strong>Add to Home Screen</strong> to install.
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
